import COLORS from '../../../style/universal.color';
import defaultTheme from './default';

const darkTheme = {
    ...defaultTheme,
    dark: true,
    primaryTextColor: COLORS.mlbWhite,
    primaryLinkColor: COLORS.linkBlue,
    primaryLinkHoverColor: COLORS.linkBlueOnDarkHover,
    disabledLinkColor: COLORS.mlbGrey4,
};

export default darkTheme;
